import { BaseParser } from './BaseParser';
import { IParseResult, ParseResult, ValueType } from '../FormatterTypes';
import { formatterStrParamDef } from '../Utils/ParamUtils';
import { tryStringToBoolean } from '../Utils/ValueUtils';

export class TEDParseBool extends BaseParser {
  public static getInstance(): TEDParseBool {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDParseBool;

  defaultParams(): string {
    return 'TrueText="Ja";FalseText="Nej";NullText=""';
  }

  parse(text: string, params: string): IParseResult {
    let result = ParseResult.OK;
    let value: ValueType = null;

    const cmpText = text.toLowerCase();
    const defaultParams = this.defaultParams();

    if (text.length !== 0) {
      if (
        strEq(cmpText, formatterStrParamDef('TrueText', params, defaultParams))
      ) {
        value = true;
      } else if (
        strEq(cmpText, formatterStrParamDef('FalseText', params, defaultParams))
      ) {
        value = false;
      } else if (
        strEq(cmpText, formatterStrParamDef('NullText', params, defaultParams))
      ) {
        value = null;
      } else {
        const strToBool = tryStringToBoolean(text);
        if (strToBool !== null) {
          value = strToBool;
        } else {
          result = ParseResult.ERROR;
        }
      }
    }

    return {
      result,
      value,
    };
  }
}

const strEq = (str1: string, str2: string): boolean =>
  str1.toLowerCase() === str2.toLowerCase();
